import React from "react";
import { getBrandColors, darken } from "../ThemeContext";

/**
 * Standard page-header icon badge — the colored rounded-square box shown
 * next to every page title (e.g. "Performance Intelligence Dashboard").
 * Color is the tenant's configured secondary/accent color (App Settings ->
 * Branding), not hardcoded, and the same size/shadow/radius is used
 * everywhere instead of each page inventing its own variant.
 */
export default function PageHeaderIcon({ icon, size = 40, radius = 12 }) {
  const y = getBrandColors().yellow;
  return (
    <div style={{
      width: size, height: size, borderRadius: radius, flexShrink: 0,
      background: `linear-gradient(135deg, ${y}, ${darken(y)})`,
      display: "flex", alignItems: "center", justifyContent: "center",
      boxShadow: `0 3px 12px ${y}55`,
    }}>
      {icon}
    </div>
  );
}
